import React, { useState, useEffect } from "react";
import { Button } from "flowbite-react";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingOverlay from "./LoadingOverlay";
import ConfirmDialog from "./ConfirmDialog";
import MaterialGroupModal from "./modals/MaterialGroupModal";

function NewMaterialGroup() {
  const [groupName, setGroupName] = useState("");
  const [groupCode, setGroupCode] = useState("");
  const [groupNameList, setGroupNameList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    getGroupNameList();
  }, []);

  const getGroupNameList = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `https://eps.elkomprintama.com/get/api/store/group`
      );
      setGroupNameList(response.data.result);
    } catch (error) {
      toast.error(error.response.data.msg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGroupNameChange = (e) => {
    setGroupName(e.target.value.toUpperCase());
  };

  const handleGroupCodeChange = (e) => {
    setGroupCode(e.target.value.toUpperCase());
  };

  function applyStripedStyle(index) {
    return index % 2 === 0 ? "border-b bg-gray-50" : " bg-white"; // Apply the striped-row class to even-indexed rows
  }

  const insertGroupName = async (e) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `https://eps.elkomprintama.com/post/api/store/group`,
        {
          mat_group_name: groupName,
          mat_group_code: groupCode,
        }
      );
      if (response.status === 200) {
        // Access the 'msg' property from the response data
        toast.success(response.data.msg); // This will display the success message
        getGroupNameList();
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!groupName) {
      toast.warning("Please fill in material group field");
      return;
    }
    setShowConfirm(true);
    setUploadPending(true);
  };

  return (
    <>
      <div className={`w-full  rounded-lg `}>
        <label
          className={`block uppercase text-white  mb-2 tracking-wide  text-2xl text-center  font-bold `}
        >
          New Material Group
        </label>
      </div>
      <div className="   py-2 px-5 bg-gray-200  sm:rounded-lg">
        <form className="mb-5" onSubmit={handleSubmit}>
          <div className="field w-full my-2">
            <div className="control w-full  ">
              <div className="flex flex-wrap -mx-3 mb-5">
                <div className="w-5/6 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="grid-pn"
                  >
                    Material Group
                  </label>
                  <input
                    className="appearance-none block w-full border bg-white border-green-400 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-pn"
                    type="text"
                    placeholder="Material Group Name"
                    onChange={handleGroupNameChange}
                    value={groupName}
                  />
                </div>
                <div className="w-1/6 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="material_code"
                  >
                    Material Code
                  </label>
                  <input
                    className="appearance-none block w-full border bg-white border-green-400 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="material_code"
                    type="text"
                    placeholder="Material Code"
                    onChange={handleGroupCodeChange}
                    value={groupCode}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full ">
            <Button fullSized type="submit">
              Insert
            </Button>
          </div>
        </form>
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg h-[70vh]">
          <table className="text-sm text-left table-auto text-gray-500 dark:text-gray-400 w-full border-collapse">
            <thead className="sticky top-0  text-white uppercase bg-gray-600 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th
                  scope="col"
                  className="whitespace-nowrap px-5 py-5 flex-1 border-r"
                >
                  Group Id
                </th>
                <th scope="col" className="whitespace-nowrap px-5 flex-1">
                  Group Name
                </th>
                <th scope="col" className="whitespace-nowrap px-5 flex-1">
                  Group Code
                </th>
              </tr>
            </thead>
            <tbody>
              {groupNameList.map((data, index) => (
                <tr
                  onDoubleClick={() => {
                    setShowModal(true);
                    setModalData(data);
                  }}
                  className={`py-6  border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ${applyStripedStyle(
                    index
                  )}`}
                  key={data.group_id}
                >
                  <td className="whitespace-nowrap px-5 py-5 flex-1 border-r">
                    {data.group_id}
                  </td>
                  <td className="whitespace-nowrap px-5 flex-1 border-r">
                    {data.group_name}
                  </td>
                  <td className="whitespace-nowrap px-5 flex-1">
                    {data.group_code}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {isLoading && <LoadingOverlay message="loading.." />}
        {showConfirm && uploadPending && (
          <ConfirmDialog
            message="Are you sure you want to insert the data?"
            onConfirm={() => {
              setShowConfirm(false);
              insertGroupName();
              setGroupName("");
              setGroupCode("");
            }}
            onCancel={() => {
              setShowConfirm(false);
              setUploadPending(false);
            }}
          />
        )}
        {showModal ? (
          <div
            className={`fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex flex-col justify-center items-center`}
            // id="wrapper"
            // onClick={handleClose}
          >
            <MaterialGroupModal
              onClose={() => {
                setShowModal(false);
              }}
              dataSet={modalData}
              refreshData={() => getGroupNameList()}
            ></MaterialGroupModal>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default NewMaterialGroup;
